<template>
  <v-container fluid grid-list-xl fill-height align-center>
    <v-layout row wrap justify-center fill-height align-center>
      <v-btn @click="back()" large fab text left style="top: 40vh" absolute color="primary">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-flex xs12 lg11>
        <Project ref="project" :projects="projects"/>
      </v-flex>

      <v-btn @click="next()" large fab text right style="top: 40vh" absolute color="primary">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import Project from "../components/features/Project";
export default {
  components: {
    Project
  },
  data() {
    return {
      projects: [
        {
          image: require("../assets/images/RushRealty.png"),
          title: "Rush Realty",
          logo: require("../assets/images/rr-logo.png"),
          description:
            "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nulla dolorum placeat similique adipisci porro aut quasi doloribus blanditiis, sit ex quod, reprehenderit, id rem iste odit sunt minus. Eaque molestias magni, neque autem vitae quidem accusamus ipsa commodi, nulla sit ipsum iure recusandae totam reiciendis hic corrupti fugiat a! Enim!",
          technologies: [
            require("../assets/images/vue.png"),
            require("../assets/images/vuetify.png"),
            require("../assets/images/nuxt.png"),
            require("../assets/images/appengine.png")
          ]
        },
        {
          image: require("../assets/images/RevisionCredit.png"),
          title: "Revision Credit",
          logo: require("../assets/images/rc-logo.png"),

          description:
            "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nulla dolorum placeat similique adipisci porro aut quasi doloribus blanditiis, sit ex quod, reprehenderit, id rem iste odit sunt minus. Eaque molestias magni, neque autem vitae quidem accusamus ipsa commodi, nulla sit ipsum iure recusandae totam reiciendis hic corrupti fugiat a! Enim!",
          technologies: [
            require("../assets/images/vue.png"),
            require("../assets/images/vuetify.png"),
            require("../assets/images/appengine.png"),
            require("../assets/images/laravel.png")
          ]
        },
        {
          image: require("../assets/images/AustinDeveloper.png"),
          title: "Austin Developer",
          logo: require("../assets/images/ad-logo.png"),

          description:
            "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nulla dolorum placeat similique adipisci porro aut quasi doloribus blanditiis, sit ex quod, reprehenderit, id rem iste odit sunt minus. Eaque molestias magni, neque autem vitae quidem accusamus ipsa commodi, nulla sit ipsum iure recusandae totam reiciendis hic corrupti fugiat a! Enim!",
          technologies: [
            require("../assets/images/vue.png"),
            require("../assets/images/firebase.png"),
            require("../assets/images/bigquery.png"),
            require("../assets/images/dataflow.png")
          ]
        },
        {
          image: require("../assets/images/MortgageReady.png"),
          title: "Mortgage Ready",
          logo: require("../assets/images/mr-logo.png"),

          description:
            "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nulla dolorum placeat similique adipisci porro aut quasi doloribus blanditiis, sit ex quod, reprehenderit, id rem iste odit sunt minus. Eaque molestias magni, neque autem vitae quidem accusamus ipsa commodi, nulla sit ipsum iure recusandae totam reiciendis hic corrupti fugiat a! Enim!",
          technologies: [
            require("../assets/images/vue.png"),
            require("../assets/images/vuetify.png"),
            require("../assets/images/appengine.png"),
            require("../assets/images/laravel.png")
          ]
        },
        {
          image: require("../assets/images/GreenLightNetwork.png"),
          title: "Green Light Network",
          logo: require("../assets/images/gln-logo.png"),

          description:
            "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nulla dolorum placeat similique adipisci porro aut quasi doloribus blanditiis, sit ex quod, reprehenderit, id rem iste odit sunt minus. Eaque molestias magni, neque autem vitae quidem accusamus ipsa commodi, nulla sit ipsum iure recusandae totam reiciendis hic corrupti fugiat a! Enim!",
          technologies: [
            require("../assets/images/vue.png"),
            require("../assets/images/vuetify.png"),
            require("../assets/images/firebase.png"),
            require("../assets/images/firestore.png")
          ]
        }
      ]
    };
  },
  methods: {
    next() {
      this.$refs.project.next();
    },
    back() {
      this.$refs.project.back();
    }
  }
};
</script>
